<div class="">
    <div class="summary-header ">{{header}}</div>
  <div class="summary-value" >{{value}}</div>
</div>
